import ErrorMessage from 'components/account/signup/Steps/ErrorMessage'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { Formik } from 'formik'
import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'
import { signup as apiSignup } from '../../../../api'
import '../styles.scss'
import LandingLocale from 'components/common/LandingLocale'

const PagePasswordCheckEmail = (props) => {
  const MAP_FIELD_ERRORS = {
    email: I18n.t('form_input_invalid_email'),
  }

  const initialValues = {
    email: '',
  }

  const [errors, setErrors] = React.useState({})
  const [emailSuccess, setEmailSuccess] = React.useState(false)
  const [loadingForm, setLoadingForm] = React.useState(false)
  const [textEmail, setTextEmail] = useState('')

  const submitFields = (values) => {
    const errors = {}
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = MAP_FIELD_ERRORS.email
    }

    if (Object.keys(errors).length === 0) {
      setErrors({})
      sendEmail(values.email)
    } else {
      setErrors(errors)
    }
  }

  const sendEmail = (email) => {
    setTextEmail(email)
    setLoadingForm(true)
    return apiSignup.emailChangePassword({ email }).then(({ status, data }) => {
      setEmailSuccess(true)
      setLoadingForm(false)
    }).catch(({ response: { data } }) => {
      if (data.type === 'error_not_valid_email') {
        setErrors({ email: MAP_FIELD_ERRORS.email })
      } else {
        console.error("General error")
      }
      setLoadingForm(false)
    })
  }

  const btnSave = (handleSubmit) => (
    <Button className='submit-button' onClick={handleSubmit}>
      {
        loadingForm
          ? <Nixi1Spinner width={'1.5rem'} height={'1.5rem'} />
          : <div>{I18n.t('nfrl_change_password_btn_send')}</div>
      }
    </Button>
  )

  return (
    <div className='nfrl page-change-password-email'>
      <div className='animated fadeIn'>
        <div className='logo-container'>
          <img src={'/img/logo-white.svg'} alt='Logo' />
        </div>

        <Formik initialValues={initialValues} onSubmit={submitFields}>
          {({ values, handleChange, handleSubmit, isSubmitting }) => (
            <div className="page-container">
              <span className='form-title'>{!emailSuccess ? I18n.t('nfrl_change_password_title') : I18n.t('nfrl_change_password_success_title')}</span>
              {
                !emailSuccess && <span className='form-subtitle'>{I18n.t('nfrl_change_password_subtitle')}</span>
              }

              {
                emailSuccess ?
                  <div className="email-success">
                    <div>{I18n.t('nfrl_change_password_email_success1')} {textEmail}</div>
                    <div>{I18n.t('nfrl_change_password_email_success2')}</div>
                  </div>
                  : (
                    <div className="form-container">
                      <div className='personal-form'>
                        <input type='email' name='email' onChange={handleChange} value={values.email} placeholder={I18n.t('nfrl_change_password_input_email')} />

                        {errors.email ? <ErrorMessage text={errors.email} /> : null}
                      </div>

                      {btnSave(handleSubmit)}

                    </div>
                  )
              }

              {!emailSuccess && <Link className="link-return" to="/login">{I18n.t('nfrl_change_password_btn_back')}</Link>}
            </div>
          )}
        </Formik>
      </div>

      <LandingLocale
        direction='top'
        darkMode
      />
    </div>
  )
}

export default PagePasswordCheckEmail